<template>
 <div>
  <single :type="type" :productKey="productKey" @back="back" @editTabs="editTabs" v-if="isShowSingle" />
  <bundle :type="type" :productKey="productKey" @back="back" @editTabs="editTabs" v-if="isShowBundle" />
  <any :type="type" :productKey="productKey" @back="back" @editTabs="editTabs" v-if="isShowAny" />
 </div>
</template>

<script>
import single from './detail/single'
import bundle from './detail/bundle'
import any from './detail/any'
    export default {
        name: 'Detail',
        props:{
            productKey: String,
            type: Number
        },
        components: {
            single,
            bundle,
            any
        },
        data() {
            return {
              isShowSingle: false,
              isShowBundle: false,
              isShowAny: false
            }
        },
        methods: {
               async editTabs(){
               const data = await{type: this.type, key: this.productKey}
              await  this.$emit('editTabs', data)
           },
           async back(){
               await this.$emit('back')
           },
           async checkType(){
               if (this.type == 1) {
                  this.isShowSingle = await true
                   this.isShowBundle = await false,
                   this.isShowAny = await false
               }else
               if (this.type == 2) {
                  this.isShowSingle = await false
                   this.isShowBundle = await true,
                   this.isShowAny = await false
               }
               if (this.type == 3) {
                  this.isShowSingle = await false
                   this.isShowBundle = await false,
                   this.isShowAny = await true
               }
           }
        },
        created() {
            this.checkType()
        },
      
      
    }
</script>

<style lang="scss"  scoped>
   
  
</style>